import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SettingsIcon from '@material-ui/icons/Settings';
import MenuIcon from '@material-ui/icons/Menu';
import InputIcon from '@material-ui/icons/Input';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import LinkIcon from '@material-ui/icons/Link';
import ImageIcon from '@material-ui/icons/Image';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignJustifyIcon from '@material-ui/icons/FormatAlignJustify';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';

export const seedDashboard3DrawersIcons = {
  ArrowBack: ArrowBackIcon,
  Input: InputIcon,
  Menu: MenuIcon,
  Settings: SettingsIcon,
  ExpandMore,
  ExpandLess,
};

export const myInputHTMLIcons = {
  FormatBold: FormatBoldIcon,
  FormatItalic: FormatItalicIcon,
  FormatUnderlined: FormatUnderlinedIcon,
  FormatListBulleted: FormatListBulletedIcon,
  FormatListNumbered: FormatListNumberedIcon,
  Undo: UndoIcon,
  Redo: RedoIcon,
  Link: LinkIcon,
  Image: ImageIcon,
  FormatAlignLeft: FormatAlignLeftIcon,
  FormatAlignCenter: FormatAlignCenterIcon,
  FormatAlignRight: FormatAlignRightIcon,
  FormatAlignJustify: FormatAlignJustifyIcon,
};

export const seedMySnackbarIcons = {
  CheckCircle: CheckCircleIcon,
  Warning: WarningIcon,
  Error: ErrorIcon,
  Info: InfoIcon,
  Close: CloseIcon,
};

export const seedMyTableIcons = {
  Refresh: RefreshIcon,
  Edit: EditIcon,
  Delete: DeleteIcon,
  MoreVert: MoreVertIcon,
};

export const seedDetailDialogIcons = {
  ArrowBack: ArrowBackIcon,
};

export const seedCRUDFCreateFabIcons = {
  Add: AddIcon,
};

export const seedMyInputImageMultipleIcons = {
  Delete: DeleteIcon,
};

export const seedAppIcons = {
  ...seedDashboard3DrawersIcons,
  ...myInputHTMLIcons,
  ...seedMySnackbarIcons,
  ...seedMyTableIcons,
  ...seedDetailDialogIcons,
  ...seedCRUDFCreateFabIcons,
  ...seedMyInputImageMultipleIcons,
};
